

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityService } from 'app/shared/service/entity.service';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { Documentation } from './documentation.model';
import { Observable } from 'rxjs';
@Injectable()
export class DocumentationService extends EntityService<Documentation> {

    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
    }
    getDocumentationByName(name: string): Observable<Documentation> {
        let params = new HttpParams().set('name', name);
        return this._http.get<Documentation>(this._configService.config.apiUrl + '/documentation/help', { params: params });
    }
}

